module.exports = __webpack_public_path__ + "static/owl-d8457f9236c5cb15d99392202799ac76.png";